import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  JSON: { input: any; output: any; }
};

export type AcceptPrivacyPolicyInput = {
  isAccepted: Scalars['Boolean']['input'];
  policyId: Scalars['String']['input'];
};

export type AcceptPrivacyPolicyOutput = {
  __typename?: 'AcceptPrivacyPolicyOutput';
  userPrivacyPolicyAcceptance: UserPrivacyPolicyAcceptance;
};

export type AcceptTermAndConditionInput = {
  isAccepted: Scalars['Boolean']['input'];
  termAndConditionId: Scalars['String']['input'];
};

export type AcceptTermAndConditionOutput = {
  __typename?: 'AcceptTermAndConditionOutput';
  userTermAndConditionAcceptance: UserTermAndConditionAcceptance;
};

export type CheckUserAcceptanceForLatestPrivacyPolicyOutput = {
  __typename?: 'CheckUserAcceptanceForLatestPrivacyPolicyOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: PrivacyPolicy;
};

export type CheckUserAcceptanceForLatestTermAndConditionOutput = {
  __typename?: 'CheckUserAcceptanceForLatestTermAndConditionOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
};

export type CheckUserPrivacyPolicyAcceptanceInput = {
  policyId: Scalars['String']['input'];
};

export type CheckUserPrivacyPolicyAcceptanceOutput = {
  __typename?: 'CheckUserPrivacyPolicyAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  privacyPolicy: Maybe<UserPrivacyPolicyAcceptance>;
};

export type CheckUserTermAndConditionAcceptanceInput = {
  termAndConditionId: Scalars['String']['input'];
};

export type CheckUserTermAndConditionAcceptanceOutput = {
  __typename?: 'CheckUserTermAndConditionAcceptanceOutput';
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: Maybe<UserTermAndConditionAcceptance>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  enabledAt: Maybe<Scalars['DateTime']['output']>;
  expiredAt: Scalars['DateTime']['output'];
  firstname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  idNumber: Scalars['String']['output'];
  idType: IdType;
  imageUrl: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  status: UserStratus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userPrivacyPolicies: Array<UserPrivacyPolicyAcceptance>;
  username: Scalars['String']['output'];
};

export type CreatePrivacyPolicyInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreatePrivacyPolicyOutput = {
  __typename?: 'CreatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type CreateTermAndConditionInput = {
  description: Scalars['String']['input'];
  documentUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  version: Scalars['String']['input'];
};

export type CreateTermAndConditionOutput = {
  __typename?: 'CreateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

/** DOPA verification status */
export enum DopaVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
  Unauthorized = 'UNAUTHORIZED',
  Unknown = 'UNKNOWN'
}

export type EKycDocument = {
  __typename?: 'EKycDocument';
  storageObject: KycStorageObject;
  type: EKycDocumentType;
};

/** e-KYC document type */
export enum EKycDocumentType {
  CitizenCardBack = 'CITIZEN_CARD_BACK',
  CitizenCardFront = 'CITIZEN_CARD_FRONT',
  FaceImage = 'FACE_IMAGE'
}

/** e-KYC verification status */
export enum EKycDocumentVerificationStatus {
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  NotStarted = 'NOT_STARTED',
  Rejected = 'REJECTED',
  Uploaded = 'UPLOADED',
  Verified = 'VERIFIED'
}

/** e-KYC ID type */
export enum EKycIdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type EKycInfo = {
  __typename?: 'EKycInfo';
  address: Maybe<Scalars['String']['output']>;
  backCardVerified: EKycDocumentVerificationStatus;
  cardVerified: EKycDocumentVerificationStatus;
  comment: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dateOfBirth: Maybe<Scalars['DateTime']['output']>;
  documents: Array<EKycDocument>;
  email: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['DateTime']['output']>;
  faceMatchSimilarity: Maybe<Scalars['Float']['output']>;
  faceMatched: EKycDocumentVerificationStatus;
  firstname: Maybe<Scalars['String']['output']>;
  firstnameEng: Maybe<Scalars['String']['output']>;
  frontCardVerified: EKycDocumentVerificationStatus;
  id: Scalars['ID']['output'];
  idCode: Maybe<Scalars['String']['output']>;
  idNumber: Maybe<Scalars['String']['output']>;
  idType: Maybe<EKycIdType>;
  issuedDate: Maybe<Scalars['DateTime']['output']>;
  lastname: Maybe<Scalars['String']['output']>;
  lastnameEng: Maybe<Scalars['String']['output']>;
  middleName: Maybe<Scalars['String']['output']>;
  middleNameEng: Maybe<Scalars['String']['output']>;
  reasons: Maybe<Array<EKycInfoReason>>;
  status: EKycVerificationStatus;
  title: Maybe<Scalars['String']['output']>;
  titleEng: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
  verificationCheckList: Maybe<EKycVerificationCheckListObjectType>;
  verifiedAt: Maybe<Scalars['DateTime']['output']>;
  verifiedBy: Maybe<Scalars['String']['output']>;
};

export type EKycInfoReason = {
  __typename?: 'EKycInfoReason';
  id: EKycInfoReasonId;
  isPassed: Scalars['Boolean']['output'];
};

/** e-KYC info reason ID */
export enum EKycInfoReasonId {
  ClearBackCardText = 'CLEAR_BACK_CARD_TEXT',
  ClearFaceImage = 'CLEAR_FACE_IMAGE',
  ClearFrontCardText = 'CLEAR_FRONT_CARD_TEXT',
  MatchedFaceImage = 'MATCHED_FACE_IMAGE',
  MatchedIdCardInfo = 'MATCHED_ID_CARD_INFO'
}

/** e-KYC upload content type */
export enum EKycUploadContentType {
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Pdf = 'PDF',
  Png = 'PNG',
  Webp = 'WEBP'
}

export type EKycVerificationCheckListObjectType = {
  __typename?: 'EKycVerificationCheckListObjectType';
  idPhotoClarity: Scalars['Boolean']['output'];
  photoClarity: Scalars['Boolean']['output'];
  photoIdentityMatch: Scalars['Boolean']['output'];
};

/** e-KYC status */
export enum EKycVerificationStatus {
  Approved = 'APPROVED',
  Expired = 'EXPIRED',
  InProgress = 'IN_PROGRESS',
  NotRequired = 'NOT_REQUIRED',
  NotStarted = 'NOT_STARTED',
  PendingApproval = 'PENDING_APPROVAL',
  Rejected = 'REJECTED',
  Terminated = 'TERMINATED'
}

export enum ExamEventExamineeResultCertificateType {
  SocialMedia = 'SOCIAL_MEDIA',
  Unofficial = 'UNOFFICIAL'
}

export type FinishKycVerificationInput = {
  userId: Scalars['String']['input'];
};

export type GetAllPrivacyPoliciesInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllPrivacyPoliciesOutput = {
  __typename?: 'GetAllPrivacyPoliciesOutput';
  privacyPolicies: Array<PrivacyPolicy>;
};

export type GetAllTermAndConditionsInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetAllTermAndConditionsOutput = {
  __typename?: 'GetAllTermAndConditionsOutput';
  termAndConditions: Array<TermAndCondition>;
};

export type GetEKycUploadSignedUrlOutput = {
  __typename?: 'GetEKycUploadSignedUrlOutput';
  signedUrl: Scalars['String']['output'];
  storageObject: StorageObject;
};

export type GetKycInfoByUserIdInput = {
  userId: Scalars['String']['input'];
};

export type GetLatestActivePrivacyPolicyOutput = {
  __typename?: 'GetLatestActivePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetLatestActiveTermAndConditionOutput = {
  __typename?: 'GetLatestActiveTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type GetPrivacyPolicyByIdOutput = {
  __typename?: 'GetPrivacyPolicyByIdOutput';
  privacyPolicy: PrivacyPolicy;
};

export type GetPrivacyPolicyByUdInput = {
  id: Scalars['String']['input'];
};

export type GetPublicCertificateByExamEventExamineeIdInput = {
  examEventExamineeId: Scalars['String']['input'];
  type: ExamEventExamineeResultCertificateType;
};

export type GetPublicCertificateByExamEventExamineeIdOutput = {
  __typename?: 'GetPublicCertificateByExamEventExamineeIdOutput';
  publicCertificateUrl: Scalars['String']['output'];
};

export type GetPublicCertificateByIdInput = {
  id: Scalars['String']['input'];
};

export type GetPublicCertificateByIdOutput = {
  __typename?: 'GetPublicCertificateByIdOutput';
  publicCertificateUrl: Scalars['String']['output'];
};

export type GetTermAndConditionByIdInput = {
  id: Scalars['String']['input'];
};

export type GetTermAndConditionByIdOutput = {
  __typename?: 'GetTermAndConditionByIdOutput';
  termAndCondition: TermAndCondition;
};

export type GetUploadSignedUrlInput = {
  contentType: EKycUploadContentType;
  userId: Scalars['String']['input'];
};

export type GetUserByTokenInput = {
  token: Scalars['String']['input'];
};

export type GetUserByTokenOutput = {
  __typename?: 'GetUserByTokenOutput';
  user: ClientUser;
};

export type GetUserImageDownloadSignedUrlOutput = {
  __typename?: 'GetUserImageDownloadSignedUrlOutput';
  signedUrls: Scalars['JSON']['output'];
};

export type GetUserPrivacyPoliciesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserPrivacyPoliciesOutput = {
  __typename?: 'GetUserPrivacyPoliciesOutput';
  userPrivacyPolicyAcceptances: Array<UserPrivacyPolicyAcceptance>;
};

export type GetUserTermAndConditionAcceptancesInput = {
  acceptOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetUserTermAndConditionAcceptancesOutput = {
  __typename?: 'GetUserTermAndConditionAcceptancesOutput';
  userTermAndConditionAcceptances: Array<UserTermAndConditionAcceptance>;
};

export enum IdType {
  CitizenCard = 'CITIZEN_CARD',
  Passport = 'PASSPORT'
}

export type KycStorageObject = {
  __typename?: 'KYCStorageObject';
  bucket: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
  type: StorageObjectProvider;
};

export type Mutation = {
  __typename?: 'Mutation';
  cluAcceptPrivacyPolicy: AcceptPrivacyPolicyOutput;
  cluAcceptTermAndCondition: AcceptTermAndConditionOutput;
  cluCreatePrivacyPolicy: CreatePrivacyPolicyOutput;
  cluCreateTermAndCondition: CreateTermAndConditionOutput;
  cluUpdatePrivacyPolicy: UpdatePrivacyPolicyOutput;
  cluUpdateTermAndCondition: UpdateTermAndConditionOutput;
  kycFinishKycVerification: EKycInfo;
  kycReadCitizenCardBack: EKycInfo;
  kycReadCitizenCardFront: EKycInfo;
  kycUpdateKycInfo: EKycInfo;
  kycVerifyCitizenCard: VerifyCitizenCardOutput;
  kycVerifyFaceSimilarity: EKycInfo;
};


export type MutationCluAcceptPrivacyPolicyArgs = {
  AcceptPrivacyPolicyInput: AcceptPrivacyPolicyInput;
};


export type MutationCluAcceptTermAndConditionArgs = {
  AcceptTermAndConditionInput: AcceptTermAndConditionInput;
};


export type MutationCluCreatePrivacyPolicyArgs = {
  CreatePrivacyPolicyInput: CreatePrivacyPolicyInput;
};


export type MutationCluCreateTermAndConditionArgs = {
  CreateTermAndConditionInput: CreateTermAndConditionInput;
};


export type MutationCluUpdatePrivacyPolicyArgs = {
  UpdatePrivacyPolicyInput: UpdatePrivacyPolicyInput;
};


export type MutationCluUpdateTermAndConditionArgs = {
  UpdateTermAndConditionInput: UpdateTermAndConditionInput;
};


export type MutationKycFinishKycVerificationArgs = {
  FinishKycVerificationInput: FinishKycVerificationInput;
};


export type MutationKycReadCitizenCardBackArgs = {
  ReadCitizenCardInput: ReadCitizenCardInput;
};


export type MutationKycReadCitizenCardFrontArgs = {
  ReadCitizenCardInput: ReadCitizenCardInput;
};


export type MutationKycUpdateKycInfoArgs = {
  UpdateKycInfoInput: UpdateKycInfoInput;
};


export type MutationKycVerifyCitizenCardArgs = {
  VerifyCitizenCardInput: VerifyCitizenCardInput;
};


export type MutationKycVerifyFaceSimilarityArgs = {
  VerifyFaceSimilarityInput: VerifyFaceSimilarityInput;
};

export type PrivacyPolicy = {
  __typename?: 'PrivacyPolicy';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  certGetPublicCertificateByExamEventExamineeId: GetPublicCertificateByExamEventExamineeIdOutput;
  certGetPublicCertificateById: GetPublicCertificateByIdOutput;
  cluCheckUserAcceptanceForLatestPrivacyPolicy: CheckUserAcceptanceForLatestPrivacyPolicyOutput;
  cluCheckUserAcceptanceForLatestTermAndCondition: CheckUserAcceptanceForLatestTermAndConditionOutput;
  cluCheckUserPrivacyPolicyAcceptance: CheckUserPrivacyPolicyAcceptanceOutput;
  cluCheckUserTermAndConditionAcceptance: CheckUserTermAndConditionAcceptanceOutput;
  cluGetAllPrivacyPolicies: GetAllPrivacyPoliciesOutput;
  cluGetAllTermAndConditions: GetAllTermAndConditionsOutput;
  cluGetLatestActivePrivacyPolicy: GetLatestActivePrivacyPolicyOutput;
  cluGetLatestActiveTermAndCondition: GetLatestActiveTermAndConditionOutput;
  cluGetMyProfile: ClientUser;
  cluGetPrivacyPolicyById: GetPrivacyPolicyByIdOutput;
  cluGetTermAndConditionById: GetTermAndConditionByIdOutput;
  cluGetUserByToken: GetUserByTokenOutput;
  cluGetUserImageDownloadSignedUrl: GetUserImageDownloadSignedUrlOutput;
  cluGetUserPrivacyPolicies: GetUserPrivacyPoliciesOutput;
  cluGetUserTermAndConditionAcceptances: GetUserTermAndConditionAcceptancesOutput;
  kycGetKycInfoByUserId: EKycInfo;
  kycGetTemporaryFolderUploadSignedUrl: GetEKycUploadSignedUrlOutput;
  kycGetUploadSignedUrl: GetEKycUploadSignedUrlOutput;
};


export type QueryCertGetPublicCertificateByExamEventExamineeIdArgs = {
  getPublicCertificateByExamEventExamineeIdInput: GetPublicCertificateByExamEventExamineeIdInput;
};


export type QueryCertGetPublicCertificateByIdArgs = {
  input: GetPublicCertificateByIdInput;
};


export type QueryCluCheckUserPrivacyPolicyAcceptanceArgs = {
  CheckUserPrivacyPolicyInput: CheckUserPrivacyPolicyAcceptanceInput;
};


export type QueryCluCheckUserTermAndConditionAcceptanceArgs = {
  CheckUserTermAndConditionAcceptanceInput: CheckUserTermAndConditionAcceptanceInput;
};


export type QueryCluGetAllPrivacyPoliciesArgs = {
  GetAllPrivacyPoliciesInput: GetAllPrivacyPoliciesInput;
};


export type QueryCluGetAllTermAndConditionsArgs = {
  GetAllTermAndConditionsInput: GetAllTermAndConditionsInput;
};


export type QueryCluGetPrivacyPolicyByIdArgs = {
  GetPrivacyPolicyByIdInput: GetPrivacyPolicyByUdInput;
};


export type QueryCluGetTermAndConditionByIdArgs = {
  GetTermAndConditionByIdInput: GetTermAndConditionByIdInput;
};


export type QueryCluGetUserByTokenArgs = {
  GetUserByTokenInput: GetUserByTokenInput;
};


export type QueryCluGetUserPrivacyPoliciesArgs = {
  GetUserPrivacyPoliciesInput: GetUserPrivacyPoliciesInput;
};


export type QueryCluGetUserTermAndConditionAcceptancesArgs = {
  GetUserTermAndConditionAcceptancesInput: GetUserTermAndConditionAcceptancesInput;
};


export type QueryKycGetKycInfoByUserIdArgs = {
  GetKycInfoByUserIdInput: GetKycInfoByUserIdInput;
};


export type QueryKycGetTemporaryFolderUploadSignedUrlArgs = {
  GetUploadSignedUrlInput: GetUploadSignedUrlInput;
};


export type QueryKycGetUploadSignedUrlArgs = {
  GetUploadSignedUrlInput: GetUploadSignedUrlInput;
};

export type ReadCitizenCardInput = {
  temporaryCardImageFileName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  watermarkedCardImageFileName: Scalars['String']['input'];
};

export type StorageObject = {
  __typename?: 'StorageObject';
  bucket: Scalars['String']['output'];
  fileName: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  provider: StorageProvider;
};

/** Storage object provider */
export enum StorageObjectProvider {
  Gcs = 'GCS'
}

export enum StorageProvider {
  GcloudStorage = 'GCLOUD_STORAGE'
}

export type TermAndCondition = {
  __typename?: 'TermAndCondition';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  documentUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['String']['output'];
};

export type UpdateKycInfoInput = {
  dateOfBirth?: InputMaybe<Scalars['DateTime']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  idCode?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type UpdatePrivacyPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrivacyPolicyOutput = {
  __typename?: 'UpdatePrivacyPolicyOutput';
  privacyPolicy: PrivacyPolicy;
};

export type UpdateTermAndConditionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTermAndConditionOutput = {
  __typename?: 'UpdateTermAndConditionOutput';
  termAndCondition: TermAndCondition;
};

export type UserPrivacyPolicyAcceptance = {
  __typename?: 'UserPrivacyPolicyAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  policyId: Scalars['String']['output'];
  privacyPolicy: PrivacyPolicy;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum UserStratus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Revoked = 'REVOKED'
}

export type UserTermAndConditionAcceptance = {
  __typename?: 'UserTermAndConditionAcceptance';
  acceptedAt: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isAccepted: Scalars['Boolean']['output'];
  termAndCondition: TermAndCondition;
  termAndConditionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

export type VerifyCitizenCardInput = {
  userId: Scalars['String']['input'];
};

export type VerifyCitizenCardOutput = {
  __typename?: 'VerifyCitizenCardOutput';
  dopaVerificationStatus: DopaVerificationStatus;
  eKycInfo: EKycInfo;
  message: Scalars['String']['output'];
};

export type VerifyFaceSimilarityInput = {
  temporaryFaceImageFileName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  watermarkedFaceImageFileName: Scalars['String']['input'];
};

export type GetPublicCertificateByIdQueryVariables = Exact<{
  input: GetPublicCertificateByIdInput;
}>;


export type GetPublicCertificateByIdQuery = { __typename?: 'Query', certGetPublicCertificateById: { __typename?: 'GetPublicCertificateByIdOutput', publicCertificateUrl: string } };

export type GetPublicCertificateByExamEventExamineeIdQueryVariables = Exact<{
  input: GetPublicCertificateByExamEventExamineeIdInput;
}>;


export type GetPublicCertificateByExamEventExamineeIdQuery = { __typename?: 'Query', certGetPublicCertificateByExamEventExamineeId: { __typename?: 'GetPublicCertificateByExamEventExamineeIdOutput', publicCertificateUrl: string } };


export const GetPublicCertificateByIdDocument = gql`
    query getPublicCertificateById($input: GetPublicCertificateByIdInput!) {
  certGetPublicCertificateById(input: $input) {
    publicCertificateUrl
  }
}
    `;

/**
 * __useGetPublicCertificateByIdQuery__
 *
 * To run a query within a React component, call `useGetPublicCertificateByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCertificateByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCertificateByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPublicCertificateByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables> & ({ variables: GetPublicCertificateByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>(GetPublicCertificateByIdDocument, options);
      }
export function useGetPublicCertificateByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>(GetPublicCertificateByIdDocument, options);
        }
export function useGetPublicCertificateByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>(GetPublicCertificateByIdDocument, options);
        }
export type GetPublicCertificateByIdQueryHookResult = ReturnType<typeof useGetPublicCertificateByIdQuery>;
export type GetPublicCertificateByIdLazyQueryHookResult = ReturnType<typeof useGetPublicCertificateByIdLazyQuery>;
export type GetPublicCertificateByIdSuspenseQueryHookResult = ReturnType<typeof useGetPublicCertificateByIdSuspenseQuery>;
export type GetPublicCertificateByIdQueryResult = Apollo.QueryResult<GetPublicCertificateByIdQuery, GetPublicCertificateByIdQueryVariables>;
export const GetPublicCertificateByExamEventExamineeIdDocument = gql`
    query getPublicCertificateByExamEventExamineeId($input: GetPublicCertificateByExamEventExamineeIdInput!) {
  certGetPublicCertificateByExamEventExamineeId(
    getPublicCertificateByExamEventExamineeIdInput: $input
  ) {
    publicCertificateUrl
  }
}
    `;

/**
 * __useGetPublicCertificateByExamEventExamineeIdQuery__
 *
 * To run a query within a React component, call `useGetPublicCertificateByExamEventExamineeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicCertificateByExamEventExamineeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicCertificateByExamEventExamineeIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPublicCertificateByExamEventExamineeIdQuery(baseOptions: Apollo.QueryHookOptions<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables> & ({ variables: GetPublicCertificateByExamEventExamineeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>(GetPublicCertificateByExamEventExamineeIdDocument, options);
      }
export function useGetPublicCertificateByExamEventExamineeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>(GetPublicCertificateByExamEventExamineeIdDocument, options);
        }
export function useGetPublicCertificateByExamEventExamineeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>(GetPublicCertificateByExamEventExamineeIdDocument, options);
        }
export type GetPublicCertificateByExamEventExamineeIdQueryHookResult = ReturnType<typeof useGetPublicCertificateByExamEventExamineeIdQuery>;
export type GetPublicCertificateByExamEventExamineeIdLazyQueryHookResult = ReturnType<typeof useGetPublicCertificateByExamEventExamineeIdLazyQuery>;
export type GetPublicCertificateByExamEventExamineeIdSuspenseQueryHookResult = ReturnType<typeof useGetPublicCertificateByExamEventExamineeIdSuspenseQuery>;
export type GetPublicCertificateByExamEventExamineeIdQueryResult = Apollo.QueryResult<GetPublicCertificateByExamEventExamineeIdQuery, GetPublicCertificateByExamEventExamineeIdQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    